import {createBrowserRouter, RouteObject, useNavigate} from "react-router-dom";
import App from "./App";
import Dashboard from "./pages/Dashboard";
import React from "react";
import Resource from "./pages/Resource";
import PracticePage from "./pages/Practice";
import Practice from "./pages/Practice";
import GuestHome from "./pages/guest/Home";
import Pricing from "./pages/guest/Pricing";
import About from "./pages/guest/About";
import Contact from "./pages/guest/Contact";
import Ielts from "./pages/guest/Exams/Ielts";
import Toefl from "./pages/guest/Exams/Toefl";
import Tcf from "./pages/guest/Exams/Tcf";
import Tef from "./pages/guest/Exams/Tef";
import DelfDalf from "./pages/guest/Exams/DelfDalf";
import Main from "./pages/Main";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthGuard from "./components/HOC/AuthGuard";
import Settings from "./pages/Settings";
import SettingsContext from "./context/SettingsContext";
import ResultsPage from "./pages/Results";
import PaginationContext from "./context/PaginationContext";
import PracticeTestRoom from "./components/Test/PracticeTestRoom";
import Notifications from "./pages/Notifications";
import TestResultComponent from "./components/Test/TestResultComponent";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import DataRetention from "./pages/DataRetention";
import SubscriptionContext from "./context/SubscriptionContext";
import Checkout from "./pages/Checkout";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import NotFound from "./components/Error/404";
import ServerError from "./components/Error/500";
import Continue from "./pages/Continue";
import Logout from "./pages/Logout";

export const devRouter = createBrowserRouter([{
    path: "",
    // Any crash below shows the 500 page instead of React Router's developer error screen.
    errorElement: <ServerError/>,
    element: <SubscriptionContext>
        <App/>
    </SubscriptionContext>,
    children: [{
        path: "",
        element: <GuestHome/>
    }, {
        path: "/login",
        element: <AuthGuard reverseAuth>
            <Login/>
        </AuthGuard>
    }, {
        path: "/register",
        element: <AuthGuard reverseAuth>
            <Register/>
        </AuthGuard>
    }, {
        path: "/reset-password",
        element: <ResetPassword/>
    }, {
        path: "/verify-email",
        element: <VerifyEmail/>
    },
        {
            path: "/privacy-policy",
            element: <PrivacyPolicy/>
        },
        {
            path: "/terms-of-use",
            element: <TermsOfUse/>
        },
        {
            path: "/data-retention",
            element: <DataRetention/>
        },
        {
            path: "/pricing",
            element: <Pricing/>
        }, {
            path: "/about",
            element: <About/>
        }, {
            path: "/contact",
            element: <Contact/>
        }, {
            path: "/Exams/ielts",
            element: <Ielts/>
        }, {
            path: "/Exams/toefl",
            element: <Toefl/>
        }, {
            path: "/Exams/tcf",
            element: <Tcf/>

        }, {
            path: "/Exams/tef",
            element: <Tef/>

        }, {
            path: "/Exams/delf-dalf",
            element: <DelfDalf/>
        }, {
            path: "/checkout",
            element: <Checkout/>
        },
        {
            path: "/app",
            element: <AuthGuard>
                <Main/>
            </AuthGuard>,
            children: [{
                path: "",
                element: <Dashboard/>
            }, {
                path: "/app/resources",
                element: <PaginationContext>
                    <Resource/>
                </PaginationContext>
            }, {
                path: "/app/practice",
                element: <PaginationContext>
                    <Practice/>
                </PaginationContext>
            }, {
                path: "/app/practice/:sectionName",
                element: <PaginationContext>
                    <PracticeTestRoom/>
                </PaginationContext>
            }, {
                path: "/app/settings",
                element: <SettingsContext>
                    <Settings/>
                </SettingsContext>
            }, {
                path: "/app/notifications",
                element: <PaginationContext>
                    <Notifications/>
                </PaginationContext>
            }, {
                path: "/app/results",
                element: <PaginationContext>
                    <ResultsPage/>
                </PaginationContext>
            }, {
                path: "/app/results/:sessionId",
                element: <TestResultComponent open={true}/>
            }]
        }, {
            path: "*",
            element: <NotFound/>
        }]
}])
export const guestRouter = createBrowserRouter([{
    path: "",
    // Any crash below shows the 500 page instead of React Router's developer error screen.
    errorElement: <ServerError/>,
    element: <App/>,
    children: [
        {
            path: "",
            element: <GuestHome/>
        },
        {
            // The app sends the browser here after logging out, to clear this site's session too.
            path: "/logout",
            element: <Logout/>
        },
        {
            path: "/pricing",
            element: <Pricing/>
        }, {
            path: "/about",
            element: <About/>
        }, {
            path: "/contact",
            element: <Contact/>
        }, {
            path: "/Exams/ielts",
            element: <Ielts/>
        }, {
            path: "/Exams/toefl",
            element: <Toefl/>
        }, {
            path: "/Exams/tcf",
            element: <Tcf/>

        }, {
            path: "/Exams/tef",
            element: <Tef/>

        }, {
            path: "/Exams/delf-dalf",
            element: <DelfDalf/>
        }, {
            path: "/checkout",
            element: <Checkout/>
        }, {
            path: "*",
            element: <NotFound/>
        }]
}])
export const appRouter = createBrowserRouter([{
    path: "",
    // Any crash below shows the 500 page instead of React Router's developer error screen.
    errorElement: <ServerError/>,
    element: <SubscriptionContext>
        <App/>
    </SubscriptionContext>,
    children: [
        /**
         * Auth routes sit outside the `Main` layout on purpose.
         *
         * `Main` renders `NavBar`, which reads the session cookie, so it must
         * never mount for a signed-out visitor. Guarding the layout is what
         * makes that true — but it also means anything a signed-out user has
         * to reach (sign in, and the reset/verification links mailed to them)
         * has to live as a sibling of the layout rather than inside it, or the
         * guard would redirect into itself.
         */
        {
            path: "/login",
            element: <AuthGuard reverseAuth>
                <Login/>
            </AuthGuard>
        }, {
            path: "/register",
            element: <AuthGuard reverseAuth>
                <Register/>
            </AuthGuard>
        }, {
            path: "/reset-password",
            element: <ResetPassword/>
        }, {
            path: "/verify-email",
            element: <VerifyEmail/>
        }, {
            // Receives sessions handed over from the guest site (checkout runs there).
            path: "/continue",
            element: <Continue/>
        }, {
            // The in-app plans dialog links here; without it, upgrading from the app hit the 404 page.
            path: "/checkout",
            element: <Checkout/>
        }, {
            path: "",
            element: <AuthGuard>
                <Main/>
            </AuthGuard>,
            children: [{
                path: "",
                element: <Dashboard/>
            }, {
                path: "/resources",
                element: <PaginationContext>
                    <Resource/>
                </PaginationContext>
            }, {
                path: "/practice",
                element: <PaginationContext>
                    <Practice/>
                </PaginationContext>
            }, {
                path: "/practice/:sectionName",
                element: <PaginationContext>
                    <PracticeTestRoom/>
                </PaginationContext>
            }, {
                path: "/settings",
                element: <SettingsContext>
                    <Settings/>
                </SettingsContext>
            }, {
                path: "/results",
                element: <PaginationContext>
                    <ResultsPage/>
                </PaginationContext>
            }, {
                // Result notifications link here; it was only routed on the test/dev hosts, so the link 404'd in production.
                path: "/results/:sessionId",
                element: <TestResultComponent open={true}/>
            }, {
                path: "/notifications",
                element: <PaginationContext>
                    <Notifications/>
                </PaginationContext>
            },]
        }, {
            path: "*",
            element: <NotFound/>
        }]
}])
